import Api from "./api"
import {ElNotification} from "element-plus";
import i18n from "@/i18n";
import {getPermissionKeyLabel} from "@/helpers/permissionCatalog";
import { escapeHtml } from '@/helpers/safeHtml'

const GENERIC_REASON = "__generic__"

// Multiple 403s can land in quick succession (e.g. a page firing several widget
// requests at once) — these are collapsed into a single, manually-dismissed
// notification instead of one toast per request. `notificationSeq` lets a
// stale/replaced notification's onClose skip clearing state that a newer
// notification already owns.
let pendingReasons = new Set()
let activeNotification = null
let notificationSeq = 0
let flushTimer = null

function reasonLabel(reason) {
    if (reason === GENERIC_REASON) {
        return i18n.global.t('General.ErrorsText.AccessDenied')
    }
    return getPermissionKeyLabel(reason)
}

function renderAccessDeniedNotification() {
    flushTimer = null
    const seq = ++notificationSeq

    if (activeNotification) {
        activeNotification.close()
    }

    const items = Array.from(pendingReasons).map(reasonLabel)
    const listHtml = items.map(label => `<li>${escapeHtml(label)}</li>`).join('')

    activeNotification = ElNotification({
        title: i18n.global.t('General.ErrorsText.AccessDeniedTitle'),
        message: `<div>${i18n.global.t('General.ErrorsText.MissingPermissionsIntro')}</div>`
            + `<ul style="margin:6px 0 0 18px;padding:0;">${listHtml}</ul>`,
        dangerouslyUseHTMLString: true,
        type: 'error',
        duration: 0,
        onClose: () => {
            // Only reset if nothing replaced this notification in the meantime.
            if (seq === notificationSeq) {
                activeNotification = null
                pendingReasons = new Set()
            }
        }
    })
}

function reportAccessDenied(requiredPermKeys) {
    const reasons = Array.isArray(requiredPermKeys) && requiredPermKeys.length
        ? requiredPermKeys
        : [GENERIC_REASON]
    reasons.forEach(r => pendingReasons.add(r))

    clearTimeout(flushTimer)
    flushTimer = setTimeout(renderAccessDeniedNotification, 200)
}

export default {
    sendRequest: async function (fetchData) {
        return Api.sendRequest(fetchData).catch(async data => {
            if (data?.server?.answer === 403) {

                // Some requests are optional lookups embedded inside a larger page (e.g. custom
                // fields fetched while building a report filter) — the caller already degrades
                // gracefully on its own, so a missing permission there shouldn't yank the user
                // out of what they're doing. Opt out via fetchData.suppressAccessDenied.
                if (!fetchData?.suppressAccessDenied) {
                    reportAccessDenied(data?.body?.required_perm_keys)
                }

            } else if (data?.server?.answer === 500) {
                ElNotification({
                    title: i18n.global.t('General.Error'),
                    message: (i18n?.global?.t && i18n.global.t('General.ErrorsText.ServerError')) || 'Server error',
                    type: 'error',
                })

            }
            // return data
            return new Promise((resolve, reject) => {
                reject(data)
            });
        })
    }
}
